export const colors = Object.freeze([
  'darkolivegreen',
  'sienna',
  'darkslateblue',
  'cadetblue',
  'mediumseagreen',
  'darkgoldenrod',
  'navy',
  'yellowgreen',
  'darkmagenta',
  'orangered',
  'gold',
  'chartreuse',
  'blueviolet',
  'springgreen',
  'crimson',
  'aqua',
  'deepskyblue',
  'blue',
  'thistle',
  'fuchsia',
  'dodgerblue',
  'palevioletred',
  'deeppink',
  'violet',
  'moccasin'
]);
